// data for 3D object definition for BioDigital Human Module files
export class HumanObjectRenderable {
  geometryId?: string;
  materialId?: string;
  morphId?: string;
  layer?: number;
}

export class EuclideanData {
  x?: number;
  y?: number;
  z?: number;
}

export class HumanObjectTransform {
  translate?: EuclideanData;
  rotate?: EuclideanData;
  scale?: EuclideanData;
  pivot?: EuclideanData;
}

export class SceneGraphNode {
  objectId: string;
  displayName: string;
  layer: number;
  objects?: SceneGraphNode[];
  transformId?: string;
  geometryId?: string;
  materialId?: string;
  renderables?: HumanObjectRenderable[];
  backfaces?: boolean;
  transform?: HumanObjectTransform;
}
